// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._5ZswB{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;width:320px}html[dir=ltr] ._5ZswB,html[dir=rtl] ._5ZswB{border-left:2px solid}._5ZswB svg{fill:#0a385a;height:12px;width:12px}._3wArw{border-color:#40bf60;color:#40bf60}._27-JT{border-color:#4299f0;color:#4299f0}.qzw9u{border-color:#f2a65a;color:#f2a65a}._2zRIt{border-color:#f65663;color:#f65663}.DEq6F{display:block;padding:0 16px}._2hbO7{font-size:12px;font-size:1.2rem;font-weight:700;text-transform:uppercase}._3lSBL{color:#0a385a!important;font-size:14px;font-size:1.4rem;font-weight:500}", ""]);
// Exports
exports.locals = {
	"toast__wrapper": "_5ZswB",
	"toast__wrapper--success": "_3wArw",
	"toast__wrapper--information": "_27-JT",
	"toast__wrapper--warning": "qzw9u",
	"toast__wrapper--error": "_2zRIt",
	"toast__contentWrapper": "DEq6F",
	"toast__header": "_2hbO7",
	"toast__content": "_3lSBL"
};
module.exports = exports;
